import { graphql } from '@api/highnote'

export const FREEZE_PAYMENT_CARD = graphql(`
  mutation SuspendPaymentCard($input: SuspendPaymentCardInput!) {
    suspendPaymentCard(input: $input) {
      ... on PaymentCard {
        __typename
        id
        status
      }
      ... on UserError {
        errors {
          path
          code
          description
        }
      }
    }
  }
`)

export const UNFREEZE_PAYMENT_CARD = graphql(`
  mutation ActivatePaymentCard($input: ActivatePaymentCardInput!) {
    activatePaymentCard(input: $input) {
      ... on PaymentCard {
        id
        status
      }
      ... on UserError {
        errors {
          path
          code
          description
        }
      }
    }
  }
`)
